module.exports = __webpack_public_path__ + "img/camera.58982c4f.svg";